export const InputType = {
  EMAIL: 'email',
  PASSWORD: 'password',
  TEXT: 'text',
};
